export interface SalesOrderLineFabricProcessing {
  id: string;
  salesOrderLineId: string;
  fabricProcessingFabricId: string;
}
